import { Typography } from "components/parts/Typography/Typography";
import {
  StyledTable,
  StyledTableCell,
  StyledTbody,
  StyledTbodyTd,
  StyledTbodyTr,
  StyledThead,
  StyledTheadTh,
  StyledTheadTr,
} from "components/templates/Table/styled";
import React from "react";
import { Group } from "types/graphqlapi";

const GROUP_TABLE_HEADER_COLUMN_LIST = [
  {
    columnId: "name",
    columnType: "typography",
    textAlign: "left",
    text: "グループ名",
    minWidth: "12em",
    width: "2000px",
  },
  {
    columnId: "memo",
    columnType: "typography",
    textAlign: "left",
    text: "備考",
    minWidth: "15em",
    width: "10000px",
  },
] as const;

type GroupListProps = {
  groupList: Group[];
  selectGroup: (group: Group) => void;
};

export const GroupList: React.FC<GroupListProps> = ({
  groupList,
  selectGroup,
}) => {
  return (
    <>
      <StyledTable>
        <StyledThead>
          <StyledTheadTr>
            {GROUP_TABLE_HEADER_COLUMN_LIST.map((column) => (
              <StyledTheadTh
                key={`tableHeaderColumn${column.columnId}`}
                textAlign={column.textAlign}
                minWidth={column.minWidth}
                width={column.width}
              >
                <StyledTableCell minWidth={column.minWidth}>
                  <Typography text={column.text} />
                </StyledTableCell>
              </StyledTheadTh>
            ))}
          </StyledTheadTr>
        </StyledThead>
        <StyledTbody>
          {groupList
            ?.filter((item) => item?.id != "0")
            .map((group) => (
              <StyledTbodyTr
                key={group.id}
                onClick={() => {
                  selectGroup(group);
                }}
              >
                {GROUP_TABLE_HEADER_COLUMN_LIST.map((column) => (
                  <StyledTbodyTd
                    key={`${column.columnId}Of${group.id}`}
                    textAlign={column.textAlign}
                    minWidth={column.minWidth}
                    width={column.width}
                  >
                    <StyledTableCell minWidth={column.minWidth}>
                      {(() => {
                        const key = column.columnId as keyof typeof group;
                        const groupContent = group[key]?.toString();
                        if (typeof groupContent === "string")
                          return <Typography text={groupContent} />;
                      })()}
                    </StyledTableCell>
                  </StyledTbodyTd>
                ))}
              </StyledTbodyTr>
            ))}
        </StyledTbody>
      </StyledTable>
    </>
  );
};
